export const MAIN = 'main';
export const BATH = 'bath';
